import { __ } from '../utils';
import { Add as AddIcon } from '@mui/icons-material';
import { Box, ButtonBase } from '@presov.sk/presov-ui-react';
import React from 'react';
import { Link } from 'react-router';

type Props = {
  to?: string;
  ariaLabel?: string;
  className?: string;
  show?: boolean;
  /**
   * Tlačidlo v riadku vedľa hľadania (desktop): polohu mu dáva rodič, nie
   * `position: absolute`. Bez toho je to plávajúce tlačidlo v rohu mapy, ktoré
   * si `bottom` drží samo - to je podoba pre mobil.
   */
  inline?: boolean;
  /** `bottom` na mobile; mení sa s vytiahnutým spodným panelom */
  mobileBottom?: number | string;
};

/**
 * Tlačidlo nového podnetu nad mapou. V riadku s hľadaním (`inline`) je to
 * pilulka s textom, plávajúce nad mapou okrúhle „+" - nie preto, že by sa text
 * nezmestil, ale preto, že na mobile je nad ním spodná lišta a sheet, takže
 * musí byť čo najmenšie a musí sa vedieť posunúť.
 */
const NewReportFab: React.FC<Props> = ({
  to = '/podnety/novy',
  ariaLabel = __('Pridať nový podnet'),
  className,
  show = true,
  inline = false,
  mobileBottom = 90,
}) => {
  return (
    <ButtonBase
      className={className}
      component={Link}
      to={to}
      aria-label={ariaLabel}
      sx={(theme) => ({
        display: show ? 'flex' : 'none',
        alignItems: 'center',
        gap: 1,
        flex: 'none',
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        fontSize: theme.typography.pxToRem(14),
        fontWeight: 700,
        borderRadius: `${theme.shape.borderRadiusFull}px`,
        boxShadow: '0 8px 22px rgba(196, 0, 11, 0.30)',
        transition: 'bottom .26s ease, background-color 120ms',
        '&:hover': { backgroundColor: theme.palette.primary.dark },
        ...(inline
          ? {
              position: 'relative',
              // 38 px z handoffu - rovnako vysoké ako hľadanie vedľa a ako
              // legenda v druhom rohu mapy.
              height: theme.typography.pxToRem(38),
              padding: theme.spacing(0, 2, 0, 0.875),
            }
          : {
              position: 'absolute',
              zIndex: 3,
              right: 14,
              bottom: mobileBottom,
              width: 52,
              height: 52,
              justifyContent: 'center',
              padding: 0,
            }),
      })}
    >
      {inline ? (
        <>
          <Box
            component='span'
            sx={{
              display: 'grid',
              placeItems: 'center',
              width: 24,
              height: 24,
              borderRadius: '999px',
              backgroundColor: 'rgba(255, 255, 255, 0.20)',
            }}
          >
            <AddIcon sx={{ fontSize: 17 }} />
          </Box>
          {__('Podnet')}
        </>
      ) : (
        <AddIcon sx={{ fontSize: 26 }} />
      )}
    </ButtonBase>
  );
};

export default NewReportFab;
